import cancellable from './cancellable'
import connect from './connect'
import create from './create'
import emit from './emit'
import identify from './identify'
import listen from './listen'
import loggable from './loggable'
import stateful from './stateful'
import stats from './stats'
import disposable from './disposable'
import namespace from './namespace'

export default {
  cancellable,
  connect,
  create,
  disposable,
  emit,
  identify,
  listen,
  loggable,
  stateful,
  stats,
  namespace
}



// WEBPACK FOOTER //
// ./src/behaviours/index.js